<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('receiving-account-configuration')" v-if="permissionCodes.indexOf('006001000') !== -1">
        <i class="el-icon-damai-page_shoukuanzhanghu"></i>
        <span slot="title">收款账户配置</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('pay-record')" v-if="permissionCodes.indexOf('006002000') !== -1">
        <i class="el-icon-damai-jiaofeijilu"></i>
        <span slot="title">缴费记录</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('pay-service-log')" v-if="permissionCodes.indexOf('006003000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
  import navMixin from '../../utils/nav'
  import {bus} from '../../utils/bus'

  const indexOfRouterNameEntities = Object.entries({
    '1': ['receiving-account-configuration', 'receiving-account-modify'],
    '2': ['pay-record'],
    '3': 'pay-service-log'
  })

  export default {
    name: 'pay-service-nav',
    mixins: [navMixin],
    computed:{
      defaultActiveMenuIndex () {
        const {name: routeName} = this.$route
        const entity = indexOfRouterNameEntities
          .find(([, routeNames]) => {
            if (routeNames instanceof Array) {
              return routeNames.indexOf(routeName) >= 0
            } else {
              return routeNames === routeName
            }
          })
        return entity && entity[0]
      }
    },
    data () {
      return {
        isCollapse: false,
        permissionCodes: '',
        indexOfRouterNameEntities
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
    },
    mounted() {
    bus.vue.$on('changeIsCollapse', data => {
      this.isCollapse = data
      })
    },
    methods: {
      toNewRouter (name) {
        this.$router.push({
          name: name
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/PayService/PayServiceNav.vue